<!-- 海报列表 -->
<template>
  <div>
    <div class="top-view">
      <div class="top-title">{{$route.query.from == 'miniApp' ? '' : '我的海报共被' + pv + '人浏览过'}} </div>
      <div class="my-poster-btn" @click="myposter">我的海报</div>
    </div>
    <div class="top-tips">免费制作，快速拥有属于您自己的宣传海报！</div>
    <div class="model-title">海报模板</div>
    <div class="model-view">
      <van-row gutter="13">
        <van-col span="12" v-for="(item, index) in dataList" :key="index">
          <div class="model" @click="toDetail(item)">
            <van-image :src="item.img"/>
          </div>
          <div class="model-card-title">{{item.title}}</div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      dataList: [],
      pv: 0
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    myposter() {
      window.I.$RangersEvent('posterListPage_myPosterBtn_click')
      this.$router.push({
        name: 'myPoster'
      })
    },
    toDetail(item) {
      this.$store.commit('setTemplate', JSON.stringify(item));
      this.$router.push({
        name: 'showModel',
        query: {item: JSON.stringify(item),theme: this.$route.query.theme}
      })
    },
    getData() {
      this.$Toast.loading({
        message: '',
        forbidClick: true,
      });
      this.$http.getTemplateList({}).then(res => {
        this.$Toast.clear();
        var data = res.data;
        this.dataList = data.list;
        this.pv = data.pv;
      }).catch(error => {
        // Dialog({ message: error.data.message });
      })
    },
    
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    var queryToken = this.$route.query.Token ? this.$route.query.Token : this.$route.query.token;
    var exhibitorId = this.$route.query.exhibitorId
    var exhibitionId = this.$route.query.exhibitionId
    var useraccount_id = this.$route.query.useraccount_id
    var appId = this.$route.query.appId
    var from = this.$route.query.from
    if (useraccount_id) {
      this.$store.commit('changeUseraccountId', useraccount_id);
    }
    if (from == 'miniApp') {
      // 小程序海报
      this.$store.commit('changeFrom', from)
    }
    var token = this.$tools.decodeToken(queryToken);
    if (token) {
      this.$store.commit('changeToken', token);
    }
    if (exhibitorId) {
      this.$store.commit('changeExhibitorId', exhibitorId);
    }
    if (exhibitionId) {
      this.$store.commit('changeExhibitionId', exhibitionId);
    }
    if (appId) {
      this.$store.commit('changeAppID', appId);
    }
    this.getData();
    window.I.$RangersEvent('posterListPage_view')
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {},
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.top-view {
  background: #F1F8FF;
  padding: 29px 15px;
  display: flex;
}
.top-title {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4B95FF;
  flex: 1;
}
.my-poster-btn {
  padding: 0px 12px;
  height: 31px;
  line-height: 31px;
  background: var(--bgcolor);
  text-align: center;
  border-radius: 15.5px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
}
.top-tips {
  margin-top: 11px;
  text-align: center;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.model-title {
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-top: 30px;
  margin-left: 15px;
}
.model-view {
  padding: 12px 15px;
}
.model {
  /* height: 266px; */
  background-color: #f7f7f7;
  margin-bottom: 12px;
  overflow: hidden;
}
.model-card-title {
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-bottom: 12px;
}
</style>
